// ======================================================================
// File Name       : ContentNotificationTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import ContentSearchForm from '../../components/content/ContentNotificationSearchInput';
import ContentSearchResult from '../../components/content/ContentNotificationSearchResult';
import * as ContentAction from '../../actions/content/ContentAction';
import * as Constant from '../../constants/index';
import * as Path from '../../constants/PathConstants';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import * as actionType from '../../constants/actionTypes/page';

class ContentNotificationTopContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        notifyMessageSetSecernId: '',
        notifyMessageSetName: '',
        returnMaxNum: Constant.RETURN_MAX_NUM,
        startPosition: 0,
        notifyMessageSortType: 9,
        ascendingDescendingSort: Constant.ASCENDING_DESCENDING_SORT.ASCENDING,
      },
      notifyMessageList: [],
      recordNum: 0,
      isAllowShowSearchMessage: false,
      isInit: true,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.onDownloadMessage = this.onDownloadMessage.bind(this);
    this.searchMessageData = this.searchMessageData.bind(this);
    this.validation = this.validation.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const search = nextProps.content.notification.search;
    const { notifyMessageList } = search;
    const { recordNum } = search;
    this.setState({ notifyMessageList, recordNum });
  }

  componentWillMount() {
    if (this.props.parentPath === Path.CONTENT_DRILL_NOTIFICATION_LIST) {
      this.setState({
        ...this.state,
        searchData: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.searchMessageData();
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_DRILL_NOTIFICATION_LIST,
      searchCondition: this.state.searchData,
    });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    const searchData = { ...this.state.searchData, ...{ [name]: value } };
    this.setState({
      searchData,
    });
  }

  onSearchBtnClick() {
    const searchData = {
      ...this.state.searchData,
      startPosition: 0,
      notifyMessageSortType: 9,
      ascendingDescendingSort: Constant.ASCENDING_DESCENDING_SORT.ASCENDING,
    };
    this.setState(
      {
        searchData,
        isAllowShowSearchMessage: false,
        isInit: false,
      },
      () => {
        const isValid = this.validation();
        if (!isValid) {
          return;
        }
        this.searchMessageData();
      },
    );
  }

  searchMessageData() {
    this.props.dispatch(ContentAction.contentNotificationSearch(this.state.searchData)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  handleSortState(row) {
    const isValid = this.validation();
    if (!isValid) {
      return;
    }
    const searchData = {
      ...this.state.searchData,
      startPosition: 0,
      notifyMessageSortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    };

    this.setState(
      {
        searchData,
      },
      () => {
        this.searchMessageData();
      },
    );
  }

  getStartEndData(startPosition) {
    const isValid = this.validation();
    if (!isValid) {
      return;
    }
    const { searchData } = this.state;
    searchData.startPosition = startPosition;
    this.setState(
      {
        searchData,
      },
      () => {
        this.searchMessageData();
      },
    );
  }

  onDownloadMessage(id) {
    const params = {
      notifyMessageSetSecernId: id,
    };
    this.props.dispatch(ContentAction.downloadContentNotificationMessage(params));
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const { contents } = this.props;
    this.refsToValidate = [];
    return (
      <Col sm={12}>
        <MessageSearch
          recordNum={this.state.recordNum}
          resultList={this.state.notifyMessageList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="通知メッセージ情報の一覧" />
        <ContentSearchForm
          handleChange={this.handleInputChange}
          notifyMessageSetSecernId={this.state.searchData.notifyMessageSetSecernId}
          notifyMessageSetName={this.state.searchData.notifyMessageSetName}
          handleSearchMessage={this.onSearchBtnClick}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />

        <ContentSearchResult
          handleDownloadMessage={this.onDownloadMessage}
          handleSearchMessage={this.onSearchBtnClick}
          notifyMessageSetList={this.state.notifyMessageList}
          handleSortState={this.handleSortState}
          recordNum={this.state.recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={this.state.searchData.startPosition}
          searchData={this.state.searchData}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  return ({
    ...{ content: state.content, auth: state.authed.authedUser },
    parentPath,
    searchCondition,
  });
};

export default connect(mapStateToProps)(ContentNotificationTopContainer);
